import { array, lazy, number, object, string, type ObjectSchema } from "yup";

export interface FoodGroupResourceDto {
  id: number;
  parentId: number;
  description: string;
  descriptionPl: string | null;
  children: FoodGroupResourceDto[] | null;
}

export const foodGroupResourceSchema: ObjectSchema<FoodGroupResourceDto> =
  object().shape({
    id: number().required(),
    parentId: number().required(),
    description: string().required(),
    descriptionPl: string().nullable().default(null),
    children: array()
      .of(lazy(() => foodGroupResourceSchema.required()))
      .nullable()
      .default(null),
  });
